import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { CommonService } from 'src/providers/common';
import { ServicesProvider } from 'src/providers/services';
@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.page.html',
  styleUrls: ['./splash-screen.page.scss'],
})
export class SplashScreenPage implements OnInit {
  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  private doctorId: string = undefined;
  private common = CommonService;
  constructor(
    //private storage: StorageService,
    private route: Router,
    private platform: Platform,
   // public auth: AuthenticationService,
    private services: ServicesProvider
  ) {
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (this.previousUrl == '/login' && this.currentUrl == '/splash-screen') {
          this.platform.backButton.subscribe(() => {
            navigator['app'].exitApp();
          });
        };
      }
    });
  }

  ngOnInit() { 
    setTimeout(() => {
      if (localStorage.getItem("patient_id")) {
        this.route.navigate(['/tabs/home']);
      } else {
        this.route.navigate(['/login']);
        localStorage.setItem("FCM", "null");
      }
    }, 5000);
  }
}
